/* app/js/src/components/recording/recording-history/recording-history.component.scss */
:host {
  display: flex;
  flex-direction: column;
}
.recording-history-grid {
  height: calc(80vh - 30px);
}
.recording-history-grid ::ng-deep .recording-status > span {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.recording-history-grid ::ng-deep .recording-status > span img {
  width: 17px;
  height: 17px;
}
.cursor-pointer {
  cursor: pointer;
}
::ng-deep .ag-theme-balham * {
  font-family: "Open Sans", sans-serif;
}
::ng-deep .ag-theme-balham.hide-pagination .ag-paging-panel {
  display: none;
}
::ng-deep .ag-theme-balham .ag-header-cell::after {
  border-right: unset;
}
::ng-deep .ag-theme-balham .ag-ltr .ag-cell-focus {
  border: unset;
}
::ng-deep .ag-theme-balham .ag-root {
  border: unset;
}
::ng-deep .ag-theme-balham .ag-root .ag-header {
  border-bottom: 1px solid #e1e6eb;
}
::ng-deep .ag-theme-balham .ag-root .ag-header .ag-header-container {
  background-color: #ffffff;
  color: #879baf;
}
::ng-deep .ag-theme-balham .ag-root .ag-row {
  background-color: transparent;
  border-color: #e1e6eb;
  color: #232f3a;
}
::ng-deep .ag-theme-balham .ag-root .ag-row.ag-row-hover {
  background-color: #e1e6eb;
}
/*# sourceMappingURL=recording-history.component.css.map */
